/* eslint-disable global-require */
const List = () => import(/* webpackChunkName: "beneficiario-bundle" */ './main.vue');
const Search = () => import(/* webpackChunkName: "beneficiario-bundle" */ './search.vue');
// const Carta = () => import(/* webpackChunkName: "atualizacao-bundle" */ '../../../relatorio/beneficiario/cartaportabilidade/main.vue');

export default [
  {
    name: 'beneficiarios',
    path: '/beneficiarios',
    components: { default: List, search: Search },
    meta: {
      requiresAuth: true,
      breadcrum: 'Beneficiário',
      icon: 'male',
      can: 'list',
      on: 'beneficiario',
    },
  },
  {
    name: 'buscaSib',
    path: '/beneficiarios/busca/sib',
    components: { default: List, search: Search },
    meta: {
      requiresAuth: true,
      breadcrum: 'Beneficiário',
      visible: 'no',
    },
  },
  // {
  //   name: '/relatorio/carta-portabilidade',
  //   path: '/relatorio/carta-portabilidade',
  //   components: { default: Carta },
  //   meta: {
  //     requiresAuth: true,
  //     breadcrum: 'Carta Portabilidade',
  //     icon: 'file-pdf',
  //     can: 'list',
  //     on: 'beneficiariologado',
  //     neto: true,
  //   },
  //   children: [],
  // },
];
